'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024 from "./presto.-List-Account-Users-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473 from "./presto.-Presto-Router$$anon$73.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$72() {
  this.bnw = null;
  this.bno = null;
  this.bnp = false;
  this.bnx = null;
  this.bny = false;
  this.bnB = null;
  this.bnu = null;
  this.bnv = false;
  this.bnq = null;
  this.bnr = false;
  this.bns = null;
  this.bnt = false;
  this.bnz = false;
  this.bnA = false;
  this.bnw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnB = "ListAccountUsersPage";
}
export { $c_Lpresto_PrestoRouter$$anon$72 as $c_Lpresto_PrestoRouter$$anon$72 };
$p = $c_Lpresto_PrestoRouter$$anon$72.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$72;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$72() {
}
export { $h_Lpresto_PrestoRouter$$anon$72 as $h_Lpresto_PrestoRouter$$anon$72 };
$h_Lpresto_PrestoRouter$$anon$72.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bnw;
});
$p.M = (function() {
  if ((!this.bnp)) {
    this.bno = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnp = true;
  }
  return this.bno;
});
$p.O = (function() {
  if ((!this.bny)) {
    this.bnx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bny = true;
  }
  return this.bnx;
});
$p.D = (function() {
  return this.bnB;
});
$p.t = (function() {
  if ((!this.bnv)) {
    this.bnu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bnv = true;
  }
  return this.bnu;
});
$p.N = (function() {
  if ((!this.bnr)) {
    this.bnq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().adY(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bnr = true;
  }
  return this.bnq;
});
$p.Q = (function() {
  if ((!this.bnt)) {
    this.bns = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473.$c_Lpresto_PrestoRouter$$anon$73();
    this.bnt = true;
  }
  return this.bns;
});
$p.v = (function() {
  if ((!this.bnA)) {
    this.bnz = false;
    this.bnA = true;
  }
  return this.bnz;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee507) => ((p) => \u03b4scrutinee507.cH6(p)))($j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024.$m_Lpresto_ListAccountUsersPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$72 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$72, "presto.PrestoRouter$$anon$72", ({
  OO: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$72 as $d_Lpresto_PrestoRouter$$anon$72 };
//# sourceMappingURL=presto.-Presto-Router$$anon$72.js.map
